import { ChangeDetectorRef, Component, Input, NgZone, ViewChild } from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { TickerTableDataSource } from '../main-table-content-v2/TickerTableDataSource';
import { SystemService } from '../../../../../system/system.service';
import { SystemDTO } from '../../../../../system/system-dtos';
import { arrayNotEmpty } from '../../../../utils/utils';

@Component({
  selector: 'app-main-table-v2-paginator-decorator',
  templateUrl: './main-table-v2-paginator-decorator.component.html',
  styleUrls: ['./main-table-v2-paginator-decorator.component.scss'],
  standalone: false,
})
export class MainTableV2PaginatorDecoratorComponent {
  public pageSizes: number[] = [20, 50, 100];

  public _dataSource: TickerTableDataSource;

  public currentPageSize: number = 20;

  @Input()
  set dataSource(ds: TickerTableDataSource) {
    if (!ds) {
      return;
    }
    this._dataSource = ds;
    this._dataSource.paginator = this._paginator;
    this._dataSource.pageDataSubject.subscribe((_) => this.changeDetectorRef.detectChanges());
  }

  @ViewChild(MatPaginator)
  _paginator: MatPaginator;

  set paginator(pag: MatPaginator) {
    this._paginator = pag;
  }

  constructor(
    private changeDetectorRef: ChangeDetectorRef,
    private systemService: SystemService,
    private ngZone: NgZone
  ) {
    this.systemService.getSystem().subscribe((system: SystemDTO) => {
      if (arrayNotEmpty(system.pageSizes)) {
        this.pageSizes = system.pageSizes;
        this.currentPageSize = this.pageSizes[0];
      } else {
        this.pageSizes = [20, 50, 100];
        this.currentPageSize = 50;
      }
    });
    this.systemService.getSystem().subscribe();
  }

  onPageEvent($event: PageEvent) {
    this.changeDetectorRef.detectChanges();
  }
}
